import fakeClick from './fakeClick';
import isomorphic from './isomorphic';

/**
 * Download data to a client's machine.
 *
 * @param {object} arguments
 * @param {string} arguments.url Link or data url to download.
 * @param {string} [arguments.fileName] Name for the downloaded data. The helper will try to infer this from the url if not provided.
 *
 * @returns {undefined}
 *
 */

export let download = ({
  url,
  fileName,
}: {
  url: string;
  fileName?: string;
}): void => {
  let finalFileName =
    fileName || url.substring(url.lastIndexOf('/') + 1).split('?')[0];

  let xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  xhr.onload = () => {
    let link = isomorphic.window.document.createElement('a');
    link.href = isomorphic.URL.createObjectURL(xhr.response);
    link.download = finalFileName;
    link.style.display = 'none';
    isomorphic.window.document.body.appendChild(link);
    fakeClick(link);
    isomorphic.window.document.body.removeChild(link);
  };

  xhr.open('GET', url);
  xhr.send();
};
